export default __webpack_public_path__ + "static/media/shotdoc_logo.ddeb905a.png";